// extracted by mini-css-extract-plugin
export default {"make-offer-message-modal":"style_make-offer-message-modal__5WO1T","makeOfferMessageModal":"style_make-offer-message-modal__5WO1T"};